import { Box } from '@hivebrite/design-system/Box';
import { TagsList } from '@hivebrite/design-system/TagsList';

import { MEMBERSHIPS_TAGS } from 'hb-react/shared/apps/Memberships/constants/membership';
import { useQueryMemberships } from 'hb-react/shared/apps/Memberships/hooks//useQueryMemberships';

const MemberShipTags = ({ resetFiltersRef }) => {
  const { filters, setFilters } = useQueryMemberships();

  return (
    <Box flexWrap="wrap">
      <TagsList
        tags={MEMBERSHIPS_TAGS}
        multi
        onChange={setFilters}
        selectedTagNames={filters}
        clearFiltersRef={resetFiltersRef}
      />
    </Box>
  );
};

export default MemberShipTags;
